import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const BookIcon: FC<Props> = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="book icon">
      {/* <title>book icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0893 3.29261C13.0454 3.29261 13.8199 4.06727 13.8199 5.02252V10.6772C13.3234 10.2655 12.6858 10.018 11.9903 10.018H5.75548C5.67248 10.018 5.6065 9.95144 5.6065 9.86974V3.44092C5.6065 3.35923 5.67248 3.29261 5.75548 3.29261H12.0893ZM14.8584 12.8861V5.02252C14.8584 3.49354 13.6188 2.25415 12.0893 2.25415H5.75548C5.10028 2.25415 4.56804 2.78434 4.56804 3.44092V4.71366L3.69635 4.70338C3.03568 4.6962 2.49541 5.2299 2.49541 5.89079V14.5667C2.49541 15.2226 3.02696 15.7542 3.68285 15.7542H11.9903C13.5744 15.7542 14.8584 14.4702 14.8584 12.8861ZM4.56804 5.7522V9.86974C4.56804 10.5263 5.10028 11.0565 5.75548 11.0565H11.9903C13.0009 11.0565 13.8199 11.8755 13.8199 12.8861C13.8199 13.8967 13.0009 14.7157 11.9903 14.7157H3.68285C3.60047 14.7157 3.53387 14.6491 3.53387 14.5667V5.89079C3.53387 5.80811 3.60151 5.741 3.68438 5.74178C3.68445 5.74178 3.68431 5.74178 3.68438 5.74178L4.56804 5.7522ZM12.2827 12.8958C12.2827 12.609 12.0502 12.3765 11.7635 12.3765H5.21811C4.93136 12.3765 4.69888 12.609 4.69888 12.8958C4.69888 13.1825 4.93136 13.415 5.21811 13.415H11.7635C12.0502 13.415 12.2827 13.1825 12.2827 12.8958Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
    </svg>
  );
};

export default BookIcon;
